import individualServices from "../../../services/individualServices"
import userServices from "../../../services/userServices"

export const VISIBLE_PROFESSIONAL_USER_UUID =
  "1f0cc542-5dad-4031-baa8-5299c324fe3c"

const INDIVIDUAL_FILTER_KEYS = [
  "job_title",
  "profession",
  "experience",
  "industry",
  "gender",
  "markets",
  "title",
  "describe_me",
  "activity",
  "location",
  "skill",
  "race",
]

const isVisibleProfessional = (individual) =>
  individual?.uuid === VISIBLE_PROFESSIONAL_USER_UUID ||
  individual?.user_uuid === VISIBLE_PROFESSIONAL_USER_UUID

const hasIndividualSearchFilters = (searchParams = {}) =>
  INDIVIDUAL_FILTER_KEYS.some((key) => Boolean(searchParams[key]))

const formatSkills = (skills) => {
  if (Array.isArray(skills)) {
    return skills.map((skill) => skill.name).join(", ")
  }

  return skills || ""
}

export const mapProfileToSearchCard = (profile) => ({
  uuid: profile.uuid,
  full_name: profile.full_name,
  describe_me: profile.describe_me,
  skills: formatSkills(profile.skills),
  photo: profile.photo,
  chat: profile.chat,
  activity: profile.activity,
  race: profile.race,
  job_title: profile.job_title,
  gender: profile.gender,
  profession: profile.profession,
  experience: profile.experience,
  favorite: profile.favorite,
})

const professionalMatchesQuery = (profile, query) => {
  const normalizedQuery = query.trim().toLowerCase()
  const searchableText = [
    profile.full_name,
    profile.job_title,
    formatSkills(profile.skills),
    profile.profession_text,
    profile.experience_text,
  ]
    .filter(Boolean)
    .join(" ")
    .toLowerCase()

  return searchableText.includes(normalizedQuery)
}

const ericMatchesCurrentSearch = async (profile, searchGroupForApi) => {
  const query = searchGroupForApi.query?.trim()

  if (query && !professionalMatchesQuery(profile, query)) {
    return false
  }

  if (!query && !hasIndividualSearchFilters(searchGroupForApi)) {
    return true
  }

  const { data } = await individualServices.getIndividuals({
    ...searchGroupForApi,
    query: profile.full_name,
    page: 1,
  })

  return (data.individuals || []).some(isVisibleProfessional)
}

export const fetchVisibleProfessionalResults = async (searchGroupForApi) => {
  try {
    const { data: profile } = await userServices.getUser(
      VISIBLE_PROFESSIONAL_USER_UUID,
    )

    if (!profile || profile.blocked) {
      return { itemList: [], dataTotalCount: 0 }
    }

    const matchesSearch = await ericMatchesCurrentSearch(
      profile,
      searchGroupForApi,
    )

    if (!matchesSearch) {
      return { itemList: [], dataTotalCount: 0 }
    }

    return {
      itemList: [mapProfileToSearchCard(profile)],
      dataTotalCount: 1,
    }
  } catch (error) {
    console.error("Error fetching visible professional profile:", error)
    return { itemList: [], dataTotalCount: 0 }
  }
}
